import { useEffect } from 'react';
import { only } from '@pcty/utils';
/**
 * Updating the validation when the form changes
 *
 * @param {F} form The FormState
 * @param {string} formInputId The id relevant to the form
 * @param {boolean | undefined} valid The user controlled prop for valid
 * @param {string | undefined} errorMessage The user controlled prop for errorMessage
 * @param {V} validation The Validation for the input
 * @param {(value: SetStateAction<V>) => void} setValidation Setter for managing validation internally
 */
export var useUpdateValidation = function (form, formInputId, valid, errorMessage, validation, setValidation) {
    useEffect(function () {
        var _a;
        if (errorMessage !== undefined || valid !== undefined)
            return;
        if (((_a = form === null || form === void 0 ? void 0 : form.inputs) === null || _a === void 0 ? void 0 : _a[formInputId]) && form.inputs[formInputId].valid !== validation.valid) {
            setValidation(only(form.inputs[formInputId], ['valid', 'errorMessage']));
        }
    }, [form]);
};
